/* eslint-disable camelcase */

import { CANCELLED_SUBSCRIPTION_TRIAL_BLOCK_DURATION } from '@lmc/common/constants'
import { createSelector } from 'reselect'

type State = {
  global?: {
    subscriptions: any
  }
}

const getSubscriptions = (state: State) => state?.global?.subscriptions

export type PlanId =
  | 'pro'
  | 'elderly-pro-gbp-monthly'
  | 'homecare-pro-gbp-monthly'
  | 'complex-care-pro-gbp-monthly'
  | 'extra-emar-gbp-monthly'
  | 'extra-family-gbp-monthly'

const getSubscription = (state: State, id: PlanId) =>
  getSubscriptions(state)?.[id]

// Status values from: https://apidocs.chargebee.com/docs/api/subscriptions?lang=curl&&&prod_cat_ver=2#subscription_status
type SubscriptionStatus =
  | 'cancelled'
  | 'in_trial'
  | 'future'
  | 'active'
  | 'non_renewing'
  | 'paused'

type ChargebeePlan = {
  billing_period: number
  billing_period_unit: string
  cancel_schedule_created_at: number
  cancelled_at: number
  channel: string
  created_at: number
  currency_code: string
  customer_id: string
  deleted: boolean
  due_invoices_count: number
  has_scheduled_changes: boolean
  id: string
  mrr: number
  object: string
  plan_amount: number
  plan_free_quantity: number
  plan_id: PlanId
  plan_quantity: number
  plan_unit_price: number
  resource_version: number
  started_at: number
  status: SubscriptionStatus
  trial_end: number
  trial_start: number
  updated_at: number
}

export const isSubscriptionCancelled = createSelector(
  getSubscription,
  (subscription: ChargebeePlan) => {
    if (
      typeof subscription === 'object' &&
      subscription.status === 'cancelled'
    ) {
      const threeMonthsAgo =
        Date.now() - CANCELLED_SUBSCRIPTION_TRIAL_BLOCK_DURATION
      const subscriptionCreatedAt = subscription.created_at * 1000

      // Only block if subscription is cancelled AND created within last 3 months
      return subscriptionCreatedAt > threeMonthsAgo
    }
    return false
  }
)
